import { red } from '@mui/material/colors';
import { components } from './components';

const themeOptions = {
  typography: {
    fontSize: 14,
    fontFamily: "'DM Sans', sans-serif",
    body1: { fontSize: '14px' },
    body2: { fontSize: '13px' },
    h1: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h2: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h3: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
  },

  status: { danger: red[500] },
  components: { ...components },
};

export default themeOptions;
